import { normalizeBrand } from '../../utils';

export function brandFromItem(context: Record<string, any>) {
  const { item } = context;

  return normalizeBrand(item?.additionalInfo?.brandName || item.brand || item.item_brand);
}
